import {useTranslation, withTranslation} from "react-i18next";
import "./informes.scss"
import {Alert, Button, Checkbox, Radio, Tag} from "antd";
import {
    DownloadOutlined,
    SearchOutlined,
    CloseOutlined
} from "@ant-design/icons";
import {LoadingOutlined} from '@ant-design/icons';
import {Spin} from 'antd';
import React, {useEffect, useState, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {dataActions} from "../../../_actions";
import {v1 as uuidv1} from "uuid";
import {xcService} from "../../../_services/xcService";
import * as _ from "lodash";
import Select from 'react-select';
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import moment from "moment";
import {Column} from '@ant-design/plots';
import DatosTek from "./datos/tek";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import downloadjs from 'downloadjs';
import DownloadGraficos from "./pdf.datos";

const antIcon = <LoadingOutlined style={{fontSize: 80}} spin/>;


function InformesOrientador() {
    const {t} = useTranslation();
    const ref = React.createRef();
    const componentRef = useRef();
    const dispatch = useDispatch();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const userType = storage.getItem(variables.USER_TYPE);

    let tipoInforme = useRef(null);
    const [btnClicked, setBtnClicked] = useState(1);
    const [loadingInforme, setLoadingInforme] = useState(false);
    //const [tipoInforme, setTipoInforme] = useState(null);
    const [courseSel, setCourseSel] = useState(null);
    const [quest, setQuest] = useState(null);
    const [yearSel, setYearSel] = useState([]);
    const [genSel, setGenSel] = useState([]);
    const [years, setYears] = useState([]);
    const [totalAlumnos, setTotalAlumnos] = useState(0);
    const [dataInforme, setDataInforme] = useState(null);
    const [graficosArray, setGraficosArray] = useState(null);
    const [datanoFormat, setDatanoFormat] = useState(null);
    const [allData, setDataAll] = useState(null);
    const [dataExcel, setDataExcel] = useState(null)
    const [isClicked, setIsClicked] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [allAssessments, setAllAssessments] = useState(null);
    const [allCodes, setAllCodes] = useState(null);
    const [isSearch, setIsSearch] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(true);
    const [cXelence, setcXelence] = useState(false);
    const [cValidados, setcValidados] = useState(false);
    const [cValidar, setcValidar] = useState(false);
    const [cIncompleto, setcIncompleto] = useState(false);
    const [firstTime, setFirstTime] = useState(true);
    const [towns, setTowns] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [ccaa, setCCAA] = useState([]);

    const [isFiltered, setFiltered] = useState(false);

    const [cTowns, setcTowns] = useState([]);
    const [cProvince, setcProvince] = useState([]);
    const [cCCAA, setcCCAA] = useState([]);
    const [codes, setCodes] = useState([]);

    const [base64Images, setBase64Images] = useState([]);

    const [courses, setCourses] = useState([]);

    var coursesData = useSelector((state) => state.dataReducer.coursesData);

    function onlyUnique(value, index, self) {
        return self?.indexOf(value) === index;
    }

    useEffect(() => {
        xcService.get(`/v1/years`).then(({data}) => {

            setYears(data.data)
        })

        if (userType === "MASTER") {
            xcService.getToken(`/v1/master/centercodes`).then(({data}) => {

                setAllCodes(data.data.map(item => item.code).filter(onlyUnique).map(c => {
                    return {
                        label: c,
                        value: c
                    }
                }))
                setProvinces(data.data.map(item => item.province).filter(onlyUnique).map(ccaa => {
                    return {
                        text: ccaa,
                        value: ccaa
                    }
                }))
                setTowns(data.data.map(item => item.town).filter(onlyUnique).map(ccaa => {
                    return {
                        text: ccaa,
                        value: ccaa
                    }
                }))
                setCCAA(data.data.map(item => item.ccaa).filter(onlyUnique).map(ccaa => {
                    return {
                        text: ccaa,
                        value: ccaa
                    }
                }))
            })
        }
        xcService.getToken(`/v1/${userType === 'MASTER' ? 'master' : 'tutor'}/allassessments`).then(({data}) => {

            setAllAssessments(data.data)
        })

        if (userType !== "MASTER") {
            //     getDataExcel();
        }

        if (!coursesData) getCourses();
    }, []);


    const getDataExcel = () => {
        let mPayload = {codes: codes}
        xcService.postToken(`/v1/${userType === 'MASTER' ? 'master' : 'tutor'}/informes/excel/data/${courseSel}`, mPayload).then(({data}) => {


            setLoadingExcel(false)
            setDataExcel(data.data.salida);
        }).catch(err => setLoadingExcel(false))
    }

    useEffect(() => {
        if (coursesData) setCourses(coursesData);
    }, [coursesData]);


    useEffect(() => {
        if (coursesData) setCourses(coursesData);
    }, [coursesData]);
    const getCourses = () => {
        dispatch(dataActions.getCourses());
    };

    const viewInforme = (c, y, g, t) => {
        setBtnClicked(1);
        setBase64Images([]);
        setLoading(true);
        setIsClicked(true)
        setDataInforme(null);
        setLoadingInforme(false)
        let mPayload = {
            course: c,
            year: y,
            genre: g, codes: codes.map(s => s.value)
        }
        callApi(mPayload, t)
    }

    const callApi = (mPayload, t) => {

        const quests = {
            '3º ESO': 'TEK3ESO',
            '4º ESO': 'TEK4ESO',
            '1º Bachillerato': 'TEK1BAC',
            '2º Bachillerato': 'TEK2BAC',
            'FP Grado Básico': 'TEKFPB',
            'FP Grado Medio': 'TEKFPM',
        }

        setQuest(quests[getCourseName()])
        let mTipo = t;
        if (t === "TEK") {
            mTipo = quests[getCourseName()]
        }

        setIsSearch(true);
        xcService.postToken(`/v1/${userType === 'MASTER' ? 'master' : 'tutor'}/informes/total/students`, mPayload).then(({data}) => {
            if (data.data && data.data.total)
                setTotalAlumnos(data.data.total)

            xcService.postToken(`/v1/${userType === 'MASTER' ? 'master' : 'tutor'}/informes/${mTipo}`, mPayload)

                .then(({data}) => {

                    setLoading(false);
                    setDatanoFormat(data.data.newList)
                    //setDataExcel(data.data.salida);

                    if (tipoInforme.current === "CEIBA") {
                        let mAgrupado = _.groupBy(data.data.newList, "assessment_id");
                        setDataInforme(mAgrupado)
                    }
                    if (tipoInforme.current === "CERVO") {
                        let mAgrupado = _.groupBy(/*data.data.newList.filter(it => !it.assessment.area.isGoal)*/data.data.newList, "assessment_id");
                        setDataInforme(mAgrupado)
                    }
                    if (tipoInforme.current === "TEK") {
                        setDataAll(data.data.newList);
                        let mAgrupado = _.groupBy(data.data.newList, "assessment_id");
                        setDataInforme(mAgrupado)
                    }

                    setBtnClicked(2);


                }).catch(err => {
                setLoading(false);
            })
        })


    }

    const avgData = (key, i) => {
        let mData = dataInforme[key].filter(it => it.points === i);
        let avg = 0;
        if (mData && mData.length > 0) {
            avg = _.meanBy(mData, (p) => p.points);
        }

        return avg;

    }

    const getArea = (key) => {

        let mArea = tipoInforme.current === "CEIBA" ? dataInforme[key][0]?.areaCeiba :
            tipoInforme.current === "CERVO" ? dataInforme[key][0]?.areaCervo : ""
        ;

        return mArea
    }

    const calcMedia = (key) => {
        let mArray = dataInforme[key].filter(item => item.points !== 99 && item.points !== 999 && item.points !== 9999).map(item => item.points);
        let mSuma = 0;
        mArray.map(points => {

            mSuma = mSuma + points;
        })
        return Math.round((mSuma / mArray.length) * 100) / 100;

    }

    const calcN = (key) => {
        let arr = dataInforme[key].filter(item => item.points !== 99 && item.points !== 999 && item.points !== 9999).map(item => item.points);
        return arr.length

    }

    const calcDesviacion = (key) => {
        let arr = dataInforme[key].filter(item => item.points !== 99 && item.points !== 999 && item.points !== 9999).map(item => item.points);
        let mean = arr.reduce((acc, curr) => {
            return acc + curr
        }, 0) / arr.length;

        // Assigning (value - mean) ^ 2 to every array item
        arr = arr.map((k) => {
            return (k - mean) ** 2
        })

        // Calculating the sum of updated array
        let sum = arr.reduce((acc, curr) => acc + curr, 0);

        // Calculating the variance
        let variance = sum / arr.length

        // Returning the Standered deviation
        let mSuma = Math.sqrt(sum / arr.length)

        return Math.round((mSuma) * 100) / 100;

    }

    const createData = (key) => {
        let mRet = [];
        for (var i = 0; i < 11; i++) {
            let mData2 = dataInforme[key].filter(it => it.points === i);
            let avg2 = mData2.length;

            let mAgrupado = _.groupBy(dataInforme[key], "gender");

            Object.keys(mAgrupado).map((keys) => {
                let mData = mAgrupado[keys].filter(it => it.points === i);
                let avg = mData.length;
                mRet.push(
                    {
                        point: i,
                        avg: avg,
                        ftype: keys,
                        type: keys === "f" ? t("login.mujer") : keys === "m" ? t("login.hombre") : t("login.otro")
                    }
                )
            });


        }
        return _.sortBy(mRet, 'ftype');

    }

    const getCourseName = () => {

        let mResult = _.filter(courses, function (o) {
            return o.id === courseSel
        });
        return mResult[0].name;

    }
    const closeTagYear = (y) => {
        let filteredArray = yearSel.filter(item => item !== y)
        setYearSel(filteredArray)

        if (isSearch) {
            viewInforme(courseSel, filteredArray, genSel, tipoInforme.current)
        }

    }

    const closeTag = (y) => {
        let filteredArray = genSel.filter(item => item !== y)
        setGenSel(filteredArray)

        if (isSearch) {
            viewInforme(courseSel, filteredArray, genSel, tipoInforme.current)
        }

    }
    const changeInforme = (val) => {
        setBase64Images([]);
        //setTipoInforme(val)
        tipoInforme.current = val;
        // if (isSearch) {
        //     viewInforme(courseSel, yearSel, genSel, val)
        // }
    }

    const deleteFiltros = () => {
        setBtnClicked(1);
        setCourseSel(null)
        tipoInforme.current = null;
        setDataInforme(null)
        setGenSel(null);
        setCodes([]);
        setYearSel([])
    }

    useEffect(() => {
        if (courseSel && userType === "MASTER") {
            setDataExcel(null);
            // getDataExcel();
        }
    }, [courseSel])

    useEffect(() => {

        if (courseSel && userType === "MASTER") {
            setDataExcel(null);
            // getDataExcel();
        }

    }, [codes])

    const changeCourse = (val) => {
        setBase64Images([]);
        setCourseSel(val)
        setLoadingExcel(true);
        /*if (isSearch) {
            viewInforme(val, yearSel, genSel, tipoInforme)
        }*/
    }

    const onChangeYears = (checkedValues) => {
        setBase64Images([]);
        setYearSel(checkedValues)
        setLoadingExcel(true);
       /*
        if (isSearch) {
            viewInforme(courseSel, checkedValues, genSel, tipoInforme)
        }*/

    };

    const changeGen = (val) => {
        setBase64Images([]);
        setGenSel(val)
        setLoadingExcel(true);
        // if (isSearch) {
        //     viewInforme(courseSel, yearSel, val, tipoInforme)
        // }
    }

    const optionspdf = {
        orientation: 'landscape',
        unit: 'in',
        format: [4, 2]
    };


    const printDocument = async () => {

        setLoadingInforme(true);

        let base64Images = [];

        setBase64Images([]);

        if (tipoInforme.current !== "TEK") {

            const a = Object.keys(dataInforme).map((key, i) => {
                //const a = mIds.map(key => {

                const chart = document.getElementById("d" + key)
                return html2canvas(chart)
            })

            Promise.all(a).then(canvases => {

                for (const canvas of canvases) {

                    base64Images.push(canvas.toDataURL())
                }

                setLoadingInforme(false)
                const rows = base64Images.reduce(function (rows, key, index) {
                    return (index % 2 == 0 ? rows.push([key])
                        : rows[rows.length-1].push(key)) && rows;
                }, []);
                setBase64Images(rows)
            });
        }else{
            var mQuestions = allData.filter(it => (it.questionType === "SINGLE" || it.questionType === "SUBJECT" ) && !it.question.includes("recibir inf"));


            let mAgrupado = _.groupBy(mQuestions, "assessment_id");

            const a = Object.keys(mAgrupado).map((key, i) => {
                //const a = mIds.map(key => {

                const chart = document.getElementById("d" + key)
                return html2canvas(chart)
            })

            Promise.all(a).then(canvases => {

                for (const canvas of canvases) {

                    base64Images.push(canvas.toDataURL())
                }

                setLoadingInforme(false)
                const rows = base64Images.reduce(function (rows, key, index) {
                    return (index % 2 == 0 ? rows.push([key])
                        : rows[rows.length-1].push(key)) && rows;
                }, []);
                setBase64Images(rows)
            });
        }



    }


    const printDocument2 = () => {


        const input = document.getElementById('allExcel');
        html2canvas(input)
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const imgWidth = 190;
                const pageHeight = 290;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;
                let heightLeft = imgHeight;
                const doc = new jsPDF('pt', 'mm');
                let position = 0;
                doc.addImage(imgData, 'PNG', 10, 0, imgWidth, imgHeight + 25);
                heightLeft -= pageHeight;
                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    doc.addPage();
                    doc.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight + 25);
                    heightLeft -= pageHeight;
                }
                doc.save("InformePdf" + moment().format(("YYYYMMDD")) + ".pdf");
            })
        ;
    }

    const clearFilters = () => {

        setcTowns([]);
        setcProvince([]);
        setcCCAA([]);
        setCodes([]);
        setcIncompleto(false);
        setcValidar(false);
        setcValidados(false);
        setcXelence(false);
        setFiltered(false);


    }

    const onChangeAcc = (key) => {
    };

    const onChangeTowns = (value) => {
        setcTowns(value);
    };

    const onChangeCode = (value) => {
        setCodes(value);
    };
    const onChangeProvince = (value) => {
        setcProvince(value);
    };
    const onChangeCCAA = (value) => {
        setcCCAA(value);
    };
    const onChangeIncompleto = (e) => {

        setcIncompleto(e.target.checked)
    };
    const onChangeValidar = (e) => {
        setcValidar(e.target.checked);
    };
    const onChangeValidados = (e) => {
        setcValidados(e.target.checked)
    };
    const onChangeXcelence = (e) => {
        setcXelence(e.target.checked)
    };

    const descargaGraph = async (id, name) => {
        const input = document.getElementById(id);
        const canvas = await html2canvas(input, {
            scale: 1
        });
        const dataURL = canvas.toDataURL('image/png');
        downloadjs(dataURL, name + '.png', 'image/png');
    }

    return (
        <div className="container dasboard-informes dasboard-informes--admin">
            <div className={"gridInformes"}>
                <div className={"colLeftInformes"}>
                    {/* Filtros */}
                    <h3 className={"informes titulo"}>{t("datos.informes")}</h3>
                    <p className={"informes asterisk"}><span style={{color: 'red'}}>*</span> {t("camposob")}</p>
                    <h3 className={"informes subtitle"}>{t("datos.tipoin")}<span style={{color: 'red'}}>*</span></h3>
                    <Radio.Group disabled={btnClicked===2} className={"container-filters"}
                                 onChange={(value) => changeInforme(value.target.value)}
                                 value={tipoInforme.current}>
                        <Radio labelPlacement="left" className={"radioColor"}
                               value={"CEIBA"}>{t("datos.informeI")}</Radio>
                        <Radio labelPlacement="left" className={"radioColor"}
                               value={"CERVO"}>{t("datos.informeII")}</Radio>
                        <Radio labelPlacement="left" className={"radioColor"}
                               value={"TEK"}>{t("datos.informeIII")}</Radio>
                    </Radio.Group>
                    <h3 className={"informes subtitle"}>{t("login.course")}<span style={{color: 'red'}}>*</span></h3>
                    <Radio.Group  disabled={btnClicked===2} className={"container-filters"}
                                 onChange={(value) => changeCourse(value.target.value)}
                                 value={courseSel}>
                        {courses.map(item => {
                            return <Radio key={uuidv1()} className={"radioColor"} value={item.id}>{item.name}</Radio>
                        })}
                    </Radio.Group>
                    <h3 className={"informes subtitle"}>{t("datos.year")}<span style={{color: 'red'}}>*</span></h3>
                    <Radio.Group   disabled={btnClicked===2}  className={"container-filters"}
                                 onChange={(value) => onChangeYears(value.target.value)}
                                 value={yearSel}>
                        {years.map(item => {
                            return <Radio  className={"radioColor"} key={item.year} labelPlacement="left"
                                          value={item.year}>20{item.year}/20{+item.year + 1}</Radio>
                        })}
                    </Radio.Group>
                    <>
                        <h3 className={"informes subtitle"}>{t("datos.genero")}<span style={{color: 'red'}}>*</span>
                        </h3>
                        <Checkbox.Group  disabled={btnClicked===2}  className={"container-filters"}
                                        onChange={changeGen}
                                        value={genSel}>
                            <Checkbox labelPlacement="left" className={"radioColor"}
                                      value={"f"}>{t("login.mujer")}</Checkbox>
                            <Checkbox labelPlacement="left" className={"radioColor"}
                                      value={"m"}>{t("login.hombre")}</Checkbox>
                            <Checkbox labelPlacement="left" className={"radioColor"}
                                      value={"n"}>{t("login.otro")}</Checkbox>
                        </Checkbox.Group>
                        {userType === "MASTER" &&
                            <>
                                <h3    className={"informes subtitle"}>{t("filtro.codigo")}</h3>
                                <Select disabled={btnClicked===2}
                                    placeholder={t("filtro.codigos")}
                                    isMulti
                                    name="colors"
                                    onChange={setCodes}
                                    options={allCodes}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                            </>
                        }

                    </>
                    <div className={"container-buttons"}>
                        <Button disabled={!tipoInforme.current || yearSel.length < 1 || !courseSel }
                                onClick={() => deleteFiltros()} type="default"
                                icon={<CloseOutlined />}>
                            {t("borrarfiltros")}
                        </Button>
                        <Button disabled={!tipoInforme.current || yearSel.length < 1 || !courseSel }
                                onClick={() => viewInforme(courseSel, yearSel, genSel, tipoInforme.current)} type="primary"
                                icon={<SearchOutlined/>}>
                            {t("datos.aplicar")}
                        </Button>
                    </div>
                </div>
                <div className={"colRightInformes"}>


                    {isLoading &&
                        <div style={{margin: "auto", marginTop: 250}}>
                            <Spin indicator={antIcon}/>
                        </div>
                    }

                    {/* Resultados */}
                    {dataInforme &&
                        <>

                            <div className={"allExcel"} id={"allExcel"} ref={componentRef}>
                                <Alert className={"container-search-info"} type={"info"}
                                       message={<h3>{t("datos.muestra")}</h3>}
                                       description={
                                           <code>
                                               <div className={"container-buttons"}>

                                                   {! loadingInforme &&
                                                   <div><Button
                                                       loading={loadingInforme}
                                                       onClick={() => printDocument()} icon={<DownloadOutlined/>}
                                                           className={"btnWhiteBlue"}>
                                                       {t("datos.ºi")}
                                                   </Button></div>}

                                                   {base64Images && base64Images.length > 0 &&
                                                       <div><DownloadGraficos images={base64Images}  totalAlumnos={totalAlumnos}

                                                            course={getCourseName()} year={"20" + yearSel + "/20" + (+yearSel+1)} isTek={tipoInforme.current==="TEK"} tipoInforme={tipoInforme.current === "CEIBA" ?
                                                           t("datos.informeI")
                                                           : tipoInforme.current === "CERVO" ?
                                                               t("datos.informeII")
                                                               : t("datos.informeIII")}
                                                       /></div>
                                                   }

                                               </div>
                                               <p className={"info"}>
                                                   <strong>{t("datos.tamanyo")}:</strong> {totalAlumnos} {t("datos.alumnos")}
                                               </p>
                                               <p className={"info"}><strong>{t("datos.tipoin")}:</strong>&nbsp;
                                                   {tipoInforme.current === "CEIBA" ?
                                                       t("datos.informeI")
                                                       : tipoInforme.current === "CERVO" ?
                                                           t("datos.informeII")
                                                           : t("datos.informeIII")}</p>
                                               <p className={"info"}>
                                                   <strong>{t("login.course")}:</strong> {getCourseName()}</p>

                                               <p className={"info"}>
                                                   <strong>{t("datos.year")}:</strong>{"20" + yearSel + "/20" + (+yearSel+1) }
                                               </p>

                                               {genSel && genSel.length > 0 &&
                                                   <div className={"container-filter-tags"}>
                                                       <p className={"info"}><strong>{t("datos.genero")}:&nbsp;</strong>
                                                       </p>
                                                       {genSel.map(item => {
                                                           return <Tag closable={yearSel.length > 1}
                                                                       onClose={() => closeTag(item)} key={uuidv1()}
                                                                       color="blue">{item === "m" ? t("login.hombre") : item === "f" ? t("login.mujer") : t("login.otro")}</Tag>

                                                       })}
                                                   </div>
                                               }
                                           </code>
                                       }/>


                                {tipoInforme.current === "TEK" &&
                                    <>
                                        <DatosTek isType={quest} dataInforme={dataInforme} data={allData}/>
                                    </>

                                }
                                {tipoInforme.current !== "TEK" &&
                                    <div className={"container-graphic marginT"}>
                                        {Object.keys(dataInforme).map((key, i) => {
                                            return (
                                                <div className={`colPrint ${(i + 1) % 2 === 0 ? "breakpage" : ""}`}
                                                     key={"d" + key} id={"d" + key}>
                                                    <h5>{getArea(key)}</h5>
                                                    <DownloadOutlined style={{float: "right", marginTop: -40}}
                                                                      onClick={() => descargaGraph("d" + key, getArea(key))}
                                                    />
                                                    <div style={{paddingTop: 10}} key={"grap" + key} id={"grap" + key}>
                                                        <Column

                                                            isStack={true}
                                                            className={"content-graphic"}
                                                            xField={"point"}
                                                            yField={"avg"}
                                                            seriesField={"type"}
                                                            colorField={'type'}
                                                            color={({type}) => {
                                                                if (type === t("login.hombre")) {
                                                                    return '#4DF9D9';
                                                                } else {
                                                                    if (type === t("login.mujer")) {
                                                                        return '#4191C4';
                                                                    } else {
                                                                        return "#82747A"
                                                                    }
                                                                }
                                                            }}
                                                            data={createData(key)}
                                                            yAxis={{
                                                                title: {
                                                                    text: t("cantidadde"),
                                                                },

                                                            }}
                                                            xAxis={{
                                                                title: {
                                                                    text: t("puntuacion"),
                                                                },

                                                                line: {
                                                                    style: {stroke: '#fff'},
                                                                },
                                                                tickLine: {
                                                                    style: {stroke: '#fff'},
                                                                }
                                                            }}
                                                            meta={{
                                                                point: {alias: "Nota"},
                                                                avg: {alias: "Media"},
                                                            }}
                                                            label={
                                                                {
                                                                    position: 'bottom',
                                                                    style: {fill: '#FFFFFF', opacity: 0}
                                                                }
                                                            }
                                                        />
                                                        <div style={{margin: 10, fontStyle: 12}}>
                                                            <strong>{t("media")}: {calcMedia(key)}</strong>
                                                            <br/><strong>{t("desviacion")}: {calcDesviacion(key)}</strong>
                                                            <br/><strong>N: {calcN(key)}</strong>
                                                        </div>
                                                    </div>
                                                </div>


                                            )
                                        })}
                                    </div>
                                }
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>)
}

export default withTranslation()(InformesOrientador)
